<ng-container *ngIf="categoryId === 1">
  <div class="d-flex flex-column mb-2" style="margin-left: 2.8em; margin-right: 2em">
    <div class="d-flex flex-row justify-content-around mb-3" style="height: 373.5px; gap: 0.25em">
      <ng-container *ngFor="let image of product.additionalInfo?.images; let i = index">
        <ng-container *ngIf="i === 0">
          <div class="d-flex" style="height: auto; width: 100%">
            <picture class="w-100">
              <img [src]="image.thumbnail" style="width: 100%; height: 373.5px; object-fit: fill" alt="image_tour" />
            </picture>
          </div>
        </ng-container>
      </ng-container>
      <div class="d-flex flex-column" style="height: auto; width: 50%">
        <ng-container *ngFor="let image of product.additionalInfo?.images; let i = index">
          <ng-container *ngIf="i > 0 && i <= 2">
            <div *ngIf="i === 1" class="w-100 h-50">
              <picture>
                <img [src]="image.thumbnail" style="width: 100%; height: 184.5px; object-fit: fill" alt="image_tour" />
              </picture>
            </div>
            <div *ngIf="i === 2" class="w-100 h-50 mt-1" style="position: relative">
              <picture>
                <img [src]="image.thumbnail" style="width: 100%; height: 184.5px; object-fit: fill" alt="image_tour" />
              </picture>
              <button
                (click)="goTabPhotos()"
                type="button"
                class="px-4 py-2 rounded-pill d-flex align-items-center justify-content-center"
                style="border: none; background-color: #ececec; position: absolute; bottom: 1em; right: 2em"
              >
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 9px; font-weight: 600">
                  + de {{ product.additionalInfo.images.length - 1 }} fotos
                </p>
              </button>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="mx-4 mt-1">
      <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 15px; font-weight: 600">Descripción</p>

      <ng-container *ngIf="hotelDescription !== ''">
        <p class="mb-4 hotel-description" style="margin-top: 20px; font-weight: 400">
          {{ hotelDescription }}
        </p>
      </ng-container>

      <ng-container *ngIf="hotelDescription === ''">
        <p class="mb-4 hotel-description" style="margin-top: 20px; font-weight: 400">N/A</p>
      </ng-container>

      <div class="d-flex justify-content-around align-items-start flex-row w-100 mt-4 mb-4" style="width: calc(100% - 180px)">
        <div class="d-flex w-100">
          <div
            *ngFor="let column of columnsInfoHotel; let i = index"
            class="d-flex flex-column me-3 w-100"
            [ngStyle]="{ 'margin-left': i > 0 ? '10px' : 0 }"
          >
            <div *ngFor="let info of column" class="mb-4 w-100" [ngStyle]="{ color: info?.value === 'N/A' ? '##4b4b4bff' : '' }">
              <div class="d-flex align-items-center" style="gap: 5px">
                <div>
                  <img *ngIf="info?.image !== ''" class="i-description" [src]="info?.image" alt="" />
                </div>
                <div>
                  <p class="mb-0 hotel-description-title" style="line-height: 1">{{ info?.title }}</p>
                  <p class="mb-0 hotel-description" style="line-height: 1">{{ info?.value }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex" style="border-bottom: 1px solid #6c6c6e; border-top: 1px solid #6c6c6e">
        <div class="py-4 w-100">
          <p class="mb-0 hotel-description-title" style="line-height: 1">Horario de check in</p>
          <p class="mb-0 hotel-description" style="line-height: 1">
            {{ product?.additionalInfo?.TimeInformation?.checkIn ? product?.additionalInfo?.TimeInformation?.checkIn + " hs." : "N/A" }}
          </p>
        </div>
        <div class="pl-3 py-4 w-100" style="border-left: 1px solid black">
          <p class="mb-0 hotel-description-title" style="line-height: 1">Horario de check out</p>
          <p class="mb-0 hotel-description" style="line-height: 1">
            {{ product?.additionalInfo?.TimeInformation?.checkOut ? product?.additionalInfo?.TimeInformation?.checkOut + " hs." : "N/A" }}
          </p>
        </div>
      </div>

      <div style="border-bottom: 1px solid #6c6c6e">
        <p class="hotel-description-title pt-4" style="font-size: 16px; margin-bottom: 15px">Requisitos de check-in</p>
        <div class="d-flex flex-column mb-4">
          <ng-container *ngFor="let requirement of arrRequirements">
            <div class="d-flex align-items-start pr-2" style="gap: 0.25em">
              <i class="bi bi-check-lg" style="-webkit-text-stroke: 1px; line-height: 1.2"></i>
              <p class="mb-0 hotel-description" style="line-height: 1.2; margin-top: 1px">{{ requirement?.description }}</p>
            </div>
          </ng-container>
        </div>
      </div>

      <div style="border-bottom: 1px solid #6c6c6e">
        <p class="hotel-description-title pt-4" style="font-size: 16px; margin-bottom: 15px">Como llegar</p>
        <div
          class="d-flex flex-row justify-content-between align-items-end mb-4"
          *ngFor="let itemToGet of [product?.additionalInfo?.howtoget]"
        >
          <div class="d-flex">
            <p class="ml-1 mb-0 hotel-description-title">{{ itemToGet.name }}</p>
          </div>
          <p class="mb-0 hotel-description-title">{{ itemToGet.address }}</p>
        </div>
      </div>

      <div class="pt-4" *ngIf="product?.additionalInfo?.atracttions.length > 0">
        <p class="hotel-description-title pt-4" style="font-size: 16px; margin-bottom: 15px">Atracciones</p>
        <div class="d-flex justify-content-between align-items-center px-4 py-3" style="border: 1px solid #6c6c6e">
          <p class="mb-0 hotel-description-title">Cantidad de atracciones: {{ product?.additionalInfo?.atracttions.length }}</p>
          <p
            class="mb-0 hotel-description-title"
            style="cursor: pointer"
            [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
            (click)="openAtracttions(product, categoryId)"
          >
            {{ revealAtracttions ? "Ocultar detalles" : "Ver detalles" }}
          </p>
        </div>

        <div *ngIf="revealAtracttions" class="mt-2 d-flex justify-content-between" style="gap: 1em">
          <div
            class="p-4 w-100"
            style="
              border: 1px solid #6c6c6e;
              border-bottom-left-radius: 6px;
              border-top-left-radius: 6px;
              overflow-y: auto;
              max-height: 500px;
            "
            [ngStyle]="{
              'scrollbar-width': 'thin',
              'scrollbar-color': (clientSetting?.clients_setting_global?.color_main_1 || '#6c6c6e') + ' #f0f0f0'
            }"
          >
            <div class="d-flex flex-column" style="gap: 1em">
              <ng-container *ngFor="let attraction of product?.additionalInfo?.atracttions; let i = index">
                <div class="d-flex" style="gap: 0.5em">
                  <div class="attraction-number">
                    {{ i + 1 }}
                  </div>
                  <div
                    class="attraction-card py-2 px-3 w-100"
                    style="border: 1px solid #6c6c6e"
                    [class.border-bottom]="i !== product?.additionalInfo?.atracttions?.length - 1"
                  >
                    <div class="attraction-info">
                      <div class="hotel-description-title" style="line-height: 1">{{ attraction?.name }}</div>
                    </div>

                    <div class="hotel-description d-flex align-items-center mt-3">
                      <img
                        src="{{
                          attraction?.description === 'a pie'
                            ? '../../../../../../assets/icons/search-result/hotel/A_PIE.svg'
                            : '../../../../../../assets/icons/search-result/hotel/MOVILIDAD.svg'
                        }}"
                        [ngStyle]="{ width: attraction?.description === 'a pie' ? '14px' : '18px' }"
                        alt=""
                      />
                      <span class="ml-2" style="font-weight: 600">{{ attraction?.description }}</span
                      >&nbsp;{{ attraction?.arrival_time }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="w-100">
            <app-map-view
              [coordinatesArr]="coordinatesArr"
              [clientSetting]="clientSetting"
              [currencies]="currencies"
              mapMode="general"
              [currencyAgency]="currencyAgency"
            >
            </app-map-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="categoryId === 6 && subCategoryId === 6">
  <div class="d-flex flex-column mb-2">
    <usb-media-banner
      [images]="product.additionalInfo?.images || []"
      [videos]="videoItems"
      [mediaItems]="mediaItems"
      [activeMedia]="activeMedia"
      [activeMediaIndex]="activeMediaIndex"
      [showPlaceholders]="true"
      [height]="323.5"
      wrapperMargin="0px 2em 0px 2.8em"
      (openImage)="openImage.emit($event)"
      (openVideo)="openVideo.emit($event)"
      (selectMedia)="onSelectMedia($event)"
      (seeMorePhotos)="goTabPhotos()"
    ></usb-media-banner>

    <div class="d-flex flex-column" style="padding: 30px 66px 10px;">
      <h2 class="usb-modal-experience-subtitle mb-2">Descripción</h2>
      <p
        class="description-tour mb-0"
        style="
          font-family: &quot;Rubik&quot;, sans-serif;
          font-size: 15px;
          font-weight: 400;
          line-height: 1.5;
          color: #272729;
        "
      >
        {{ descriptionComplete ? fullDescription : truncatedDescription }}

        <a
          *ngIf="product.description?.length > 300"
          (click)="moreDescription()"
          class="description-tour mb-0"
          style="
            font-family: &quot;Rubik&quot;, sans-serif;
            font-size: 15px;
            font-weight: 500;
            line-height: 1.1;
            margin-top: 30px;
            color: #272729;
            cursor: pointer;
          "
        >
          {{ descriptionComplete ? "...menos" : "...más" }}
        </a>
      </p>
    </div>

    <!-- General Information -->
    <div class="usb-modal-experience-container pt-3 mb-4">
      <h2 class="usb-modal-experience-subtitle mb-1" style="padding: 0px 12px;">Información General</h2>

      <div class="row position-relative">

        <div style="position: absolute; left: 0; width: 1px; height: calc(100% - 96px); bottom: 0; right: 0; margin: auto; background-color: #b4b4b4;"></div>

        <!-- First Row -->
        <div class="col-6 px-0">
          <div class="d-flex align-items-start py-3 px-4" style="gap: 10px">
            <img src="../../../../../assets/icons/calendario.svg" width="24px" height="24px" alt="" />

            <div class="d-flex flex-column" style="padding-top: 6px; gap: 5px">
              <p class="mb-0 usb-modal-experience-subtitle small">
                Cancelación {{ product?.additionalInfo?.tours?.options[0]?.rateClass === "R" ? "gratuita" : "" }}
              </p>
              <p class="mb-0 usb-modal-experience-text small">
                <span *ngIf="product?.additionalInfo?.tours?.options[0]?.rateClass === 'R'">
                  Cancela gratis hasta {{ cancellationPolicyDate | date: "dd/MM/yyyy" }} y recibe un reembolso completo
                </span>
                <span *ngIf="product?.additionalInfo?.tours?.options[0]?.rateClass === 'NR'"> Cancelación con 100% de cargo </span>
              </p>
            </div>
          </div>
        </div>

        <div class="col-6 px-0">
          <a href="https://www.tripadvisor.es/" target="_blank" class="d-flex align-items-start py-3 px-4" style="gap: 10px; text-transform: none;">
            <img src="../../../../assets/icons/modals/modal-tours/buho.svg" width="35px" height="35px" alt="" />

            <div class="d-flex flex-column" style="padding-top: 6px; gap: 5px">
              <p class="mb-0 usb-modal-experience-subtitle small">
                Trip Advisor
              </p>
            </div>
          </a>
        </div>

        <!-- Second Row -->
        <div class="col-6 px-0">
          <div
            class="d-flex align-items-start py-3 px-4"
            style="gap: 10px; border-top: 1px solid #b4b4b4;"
          >
            <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="30px" height="30px" alt="" />

            <div class="d-flex flex-column" style="padding-top: 6px; gap: 5px">
              <p class="mb-0 usb-modal-experience-subtitle small">Duración {{ getDurations(product?.additionalInfo?.tours?.options) }}</p>
              <p class="mb-0 usb-modal-experience-text small">Suele estar disponible por la {{ periodsActivities(product?.additionalInfo?.tours?.options) }}</p>
            </div>
          </div>
        </div>

        <div *ngIf="product && product?.additionalInfo?.cutOff?.applies && product?.additionalInfo?.cutOff?.applies === true" class="col-6 pl-0">
          <div class="d-flex align-items-start py-3 px-4" style="gap: 10px; border-top: 1px solid #b4b4b4">
            <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="30px" height="30px" alt="" />

            <div class="d-flex flex-column" style="padding-top: 6px; gap: 5px">
              <p class="mb-0 usb-modal-experience-subtitle small">Hora Limite (Cut Off)</p>
              <p class="mb-0 usb-modal-experience-text small">{{ product?.additionalInfo?.cutOff?.time }} hs.</p>
            </div>
          </div>
        </div>

        <!-- Third Row -->
        <div class="col-6 px-0">
          <div
            class="d-flex align-items-start py-3 px-4"
            style="gap: 10px; border-top: 1px solid #b4b4b4;"
          >
            <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="26px" height="26px" alt="" />

            <div class="d-flex flex-column" style="padding-top: 6px; gap: 5px">
              <p class="mb-0 usb-modal-experience-subtitle small">Ubicación</p>
              <p class="mb-0 usb-modal-experience-text small">{{ product.additionalInfo.location ? product.additionalInfo.location + ", " + payload[0]?.city : payload[0]?.city }}</p>
            </div>
          </div>
        </div>

        <div class="col-6 px-0" *ngIf="product && product?.additionalInfo?.locationReference">
          <div class="d-flex align-items-start py-3 px-4" style="gap: 10px; border-top: 1px solid #b4b4b4">
            <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="26px" height="26px" alt="" />

            <div class="d-flex flex-column" style="padding-top: 6px; gap: 5px">
              <p class="mb-0 usb-modal-experience-subtitle small">Referencia de Locacion</p>
              <p class="mb-0 usb-modal-experience-text small">{{ product?.additionalInfo?.locationReference }}</p>
            </div>
          </div>
        </div>

        <!-- Fourth Row -->
        <div class="col-6 px-0">
          <div
            class="d-flex align-items-start py-3 px-4"
            style="gap: 10px; border-top: 1px solid #b4b4b4;"
          >
            <img src="../../../../assets/icons/modals/modal-tours/persona.svg" width="26px" height="26px" alt="" />

            <div class="d-flex flex-column" style="padding-top: 6px; gap: 5px">
              <p class="mb-0 usb-modal-experience-subtitle small">Capacidad</p>
              <p class="mb-0 usb-modal-experience-text small">{{product?.additionalInfo?.tours?.adults + product?.additionalInfo?.tours?.children}} {{ product?.additionalInfo?.tours?.adults + product?.additionalInfo?.tours?.children === 1 ? 'pasajero' : 'pasajeros' }}</p>
            </div>
          </div>
        </div>

        <div class="col-6 px-0" *ngIf="product && product?.antiquity">
          <div class="d-flex align-items-start py-3 px-4" style="gap: 10px; border-top: 1px solid #b4b4b4">
            <img src="../../../../assets/icons/modals/modal-tours/waiting_99156.svg" width="26px" height="26px" alt="" />

            <div class="d-flex flex-column" style="padding-top: 6px; gap: 5px">
              <p class="mb-0 usb-modal-experience-subtitle small">Antiguedad</p>
              <p class="mb-0 usb-modal-experience-text small">{{ product?.antiquity }} años</p>
            </div>
          </div>
        </div>

        <!-- Five Row -->
        <div class="col-6 px-0">
          <div
            class="d-flex align-items-start py-3 px-4"
            style="gap: 10px; border-top: 1px solid #b4b4b4;"
          >
            <img src="../../../../assets/icons/modals/modal-tours/idioma.svg" width="26px" height="26px" alt="" />

            <div class="d-flex flex-column" style="padding-top: 6px; gap: 5px">
              <p class="mb-0 usb-modal-experience-subtitle small">Idioma</p>
              <p class="mb-0 usb-modal-experience-text small">La actividad se realiza con un guia que habla {{ getLanguages(product?.additionalInfo?.tours?.options) }}</p>
            </div>
          </div>
        </div>

        <div class="col-6 px-0" *ngIf="product && product?.serviceModality">
          <div class="d-flex align-items-start py-3 px-4" style="gap: 10px; border-top: 1px solid #b4b4b4">
            <img src="../../../../assets/icons/modals/modal-tours/alerta.svg" width="26px" height="26px" alt="" />

            <div class="d-flex flex-column" style="padding-top: 6px; gap: 5px">
              <p class="mb-0 usb-modal-experience-subtitle small">Modalidad de Servicio</p>
              <p class="mb-0 usb-modal-experience-text small">
                <span *ngFor="let modality of product?.serviceModality">
                  {{ modality }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Operating Season -->
    <div class="usb-modal-experience-container mb-4" style="padding: 0px 55px 0px;"
      *ngIf="
        product &&
        product?.additionalInfo?.serviceSeason &&
        (hasSeasonDates(product?.additionalInfo?.serviceSeason?.low) ||
          hasSeasonDates(product?.additionalInfo?.serviceSeason?.medium) ||
          hasSeasonDates(product?.additionalInfo?.serviceSeason?.high))
      "
    >
      <div class="" style="background-color: #eeeeee; padding: 30px 42px">
        <h3 class="mb-3 usb-modal-experience-subtitle small">Temporada de Funcionamiento</h3>

        <div class="row">
          <div
            class="col-4"
            *ngIf="product && product?.additionalInfo?.serviceSeason?.low && hasSeasonDates(product?.additionalInfo?.serviceSeason?.low)"
          >
            <p class="usb-modal-experience-subtitle small mb-1">Temporada Baja</p>
            <p class="usb-modal-experience-text small mb-0">Desde {{ product?.additionalInfo?.serviceSeason?.low?.from | date: "dd/MM/yyyy" }}. Hasta {{ product?.additionalInfo?.serviceSeason?.low?.to | date: "dd/MM/yyyy"  }}</p>
          </div>
          <div
            class="col-4"
            *ngIf="product && product?.additionalInfo?.serviceSeason?.medium && hasSeasonDates(product?.additionalInfo?.serviceSeason?.medium)"
          >
            <p class="usb-modal-experience-subtitle small mb-1">Temporada Media</p>
            <p class="usb-modal-experience-text small mb-0">Desde {{ product?.additionalInfo?.serviceSeason?.medium?.from | date: "dd/MM/yyyy" }}. Hasta {{ product?.additionalInfo?.serviceSeason?.medium?.to | date: "dd/MM/yyyy" }}</p>
          </div>
          <div
            class="col-4"
            *ngIf="product && product?.additionalInfo?.serviceSeason?.high && hasSeasonDates(product?.additionalInfo?.serviceSeason?.high)"
          >
            <p class="usb-modal-experience-subtitle small mb-1">Temporada Alta</p>
            <p class="usb-modal-experience-text small mb-0">Desde {{ product?.additionalInfo?.serviceSeason?.high?.from | date: "dd/MM/yyyy" }}. Hasta {{ product?.additionalInfo?.serviceSeason?.high?.to | date: "dd/MM/yyyy" }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Includes Activity -->
    <div class="usb-modal-experience-container" style="padding: 0px 55px 0px;">
      <div class="" style="padding: 0px 42px" *ngIf="product && product?.additionalInfo?.includeActivity">
        <h3 class="usb-modal-experience-subtitle small mb-2">Que Incluye la Actividad</h3>
        <p class="m-0 usb-modal-experience-text small">
          {{ product?.additionalInfo?.includeActivity }}
        </p>
      </div>

      <hr style="width: 94%;" />

      <div class="" style="padding: 0px 50px" *ngIf="product?.additionalInfo?.remarks">
        <h3 class="usb-modal-experience-subtitle small mb-2">Recomendacion</h3>
        <ul style="padding-left: 10px">
          <li class="usb-modal-experience-text small" *ngFor="let remark of product?.additionalInfo?.remarks">
            {{ remark}}
          </li>
        </ul>
      </div>

      <div class="mb-4" style="padding: 0px 42px">
        <div class="row">
          <div class="col-6" *ngIf="product?.additionalInfo?.accessibility?.hasAccessibility && product?.additionalInfo?.accessibility?.hasAccessibility === true">
            <div class="w-100 h-100" style="background-color: #eeeeee; border-radius: 30px; padding: 40px 50px">
              <h3 class="usb-modal-experience-subtitle small mb-2">Accesibilidad</h3>
              <p class="usb-modal-experience-text small">
                Tipo de Accesibilidad <span style="font-weight: 600">Acceso a Rampa</span>
              </p>

              <ul class="d-flex flex-column" style="padding-left: 10px; gap: 10px;">
                <li class="d-flex align-items-start" style="gap: 10px">
                  <div class="d-flex align-items-center justify-content-center" style="width: 8px; height: 13px; padding-top: 5px;">
                    <svg style="fill: red;" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.3 30.1"><path d="M48.1,50.6a2.87,2.87,0,0,1-1.8-.7L35.5,39,24.7,49.9a2.41,2.41,0,0,1-1.8.7,2.87,2.87,0,0,1-1.8-.7,2.41,2.41,0,0,1-.7-1.8,2.87,2.87,0,0,1,.7-1.8L32,35.5,21.1,24.7a2.45,2.45,0,0,1,1.8-4.2,2.87,2.87,0,0,1,1.8.7L35.5,32,46.3,21.2a2.41,2.41,0,0,1,1.8-.7,2.87,2.87,0,0,1,1.8.7,2.42,2.42,0,0,1,0,3.5L39,35.5,49.8,46.3a2.41,2.41,0,0,1,.7,1.8,2.87,2.87,0,0,1-.7,1.8A2.06,2.06,0,0,1,48.1,50.6Z" transform="translate(-20.35 -20.5)"/></svg>
                  </div>
                  <p class="usb-modal-experience-text small m-0">Accesible a Silla de Ruedas</p>
                </li>
                <li class="d-flex align-items-start" style="gap: 10px">
                  <div class="d-flex align-items-center justify-content-center" style="width: 8px; height: 13px; padding-top: 5px;">
                    <svg style="width: 8px; height: 8px;" [ngStyle]="{ 'fill': clientSetting?.clients_setting_global?.color_main_1 }" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.1 33.2"><path d="M30.9,52.1a2.81,2.81,0,0,1-2.1-1L19.7,40.8a2.65,2.65,0,0,1-.8-1.9,2.56,2.56,0,0,1,1-1.9,2.64,2.64,0,0,1,1.9-.7,2.72,2.72,0,0,1,2.1.9l6.7,7.5L46.9,20.1a2.73,2.73,0,0,1,2.4-1.2,3.71,3.71,0,0,1,1.5.4A2.08,2.08,0,0,1,51.9,21v.2a2.09,2.09,0,0,1-.3,1.9L33.3,50.8a2.77,2.77,0,0,1-2.1,1.3Z" transform="translate(-18.9 -18.9)"/></svg>
                  </div>
                  <p class="usb-modal-experience-text small m-0">Se puede transportar la silla de ruedas en la actividad</p>
                </li>
              </ul>

              <h3 class="usb-modal-experience-subtitle small mb-2">Fotos</h3>
              <ul class="d-flex flex-column" style="padding-left: 10px; gap: 10px;">
                <li class="d-flex align-items-start" style="gap: 10px">
                  <div class="d-flex align-items-center justify-content-center" style="width: 8px; height: 13px; padding-top: 5px;">
                    <svg style="fill: red;" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.3 30.1"><path d="M48.1,50.6a2.87,2.87,0,0,1-1.8-.7L35.5,39,24.7,49.9a2.41,2.41,0,0,1-1.8.7,2.87,2.87,0,0,1-1.8-.7,2.41,2.41,0,0,1-.7-1.8,2.87,2.87,0,0,1,.7-1.8L32,35.5,21.1,24.7a2.45,2.45,0,0,1,1.8-4.2,2.87,2.87,0,0,1,1.8.7L35.5,32,46.3,21.2a2.41,2.41,0,0,1,1.8-.7,2.87,2.87,0,0,1,1.8.7,2.42,2.42,0,0,1,0,3.5L39,35.5,49.8,46.3a2.41,2.41,0,0,1,.7,1.8,2.87,2.87,0,0,1-.7,1.8A2.06,2.06,0,0,1,48.1,50.6Z" transform="translate(-20.35 -20.5)"/></svg>
                  </div>
                  <p class="usb-modal-experience-text small m-0">Se pueden sacar fotos regulares</p>
                </li>
                <li class="d-flex align-items-start" style="gap: 10px">
                  <div class="d-flex align-items-center justify-content-center" style="width: 8px; height: 13px; padding-top: 5px;">
                    <svg [ngStyle]="{ 'fill': clientSetting?.clients_setting_global?.color_main_1 }" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.1 33.2"><path d="M30.9,52.1a2.81,2.81,0,0,1-2.1-1L19.7,40.8a2.65,2.65,0,0,1-.8-1.9,2.56,2.56,0,0,1,1-1.9,2.64,2.64,0,0,1,1.9-.7,2.72,2.72,0,0,1,2.1.9l6.7,7.5L46.9,20.1a2.73,2.73,0,0,1,2.4-1.2,3.71,3.71,0,0,1,1.5.4A2.08,2.08,0,0,1,51.9,21v.2a2.09,2.09,0,0,1-.3,1.9L33.3,50.8a2.77,2.77,0,0,1-2.1,1.3Z" transform="translate(-18.9 -18.9)"/></svg>
                  </div>
                  <p class="usb-modal-experience-text small m-0">Tiene costo</p>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-6" *ngIf="product?.additionalInfo?.important_info">
            <div class="w-100 h-100" style="background-color: #eeeeee; border-radius: 30px; padding: 40px 50px">
              <h3 class="usb-modal-experience-subtitle small mb-2">Información Importante</h3>

              <ul class="d-flex flex-column" style="padding-left: 10px; gap: 10px;">
                <li *ngFor="let info of product?.additionalInfo?.important_info" class="d-flex align-items-start" style="gap: 10px">
                  <div class="d-flex align-items-center justify-content-center" style="width: 8px; height: 13px; padding-top: 5px;">
                    <!-- <svg style="fill: red;" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.3 30.1"><path d="M48.1,50.6a2.87,2.87,0,0,1-1.8-.7L35.5,39,24.7,49.9a2.41,2.41,0,0,1-1.8.7,2.87,2.87,0,0,1-1.8-.7,2.41,2.41,0,0,1-.7-1.8,2.87,2.87,0,0,1,.7-1.8L32,35.5,21.1,24.7a2.45,2.45,0,0,1,1.8-4.2,2.87,2.87,0,0,1,1.8.7L35.5,32,46.3,21.2a2.41,2.41,0,0,1,1.8-.7,2.87,2.87,0,0,1,1.8.7,2.42,2.42,0,0,1,0,3.5L39,35.5,49.8,46.3a2.41,2.41,0,0,1,.7,1.8,2.87,2.87,0,0,1-.7,1.8A2.06,2.06,0,0,1,48.1,50.6Z" transform="translate(-20.35 -20.5)"/></svg> -->
                    <svg style="width: 10px; height: 10px;" [ngStyle]="{ 'fill': clientSetting?.clients_setting_global?.color_main_1 }" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.1 33.2"><path d="M30.9,52.1a2.81,2.81,0,0,1-2.1-1L19.7,40.8a2.65,2.65,0,0,1-.8-1.9,2.56,2.56,0,0,1,1-1.9,2.64,2.64,0,0,1,1.9-.7,2.72,2.72,0,0,1,2.1.9l6.7,7.5L46.9,20.1a2.73,2.73,0,0,1,2.4-1.2,3.71,3.71,0,0,1,1.5.4A2.08,2.08,0,0,1,51.9,21v.2a2.09,2.09,0,0,1-.3,1.9L33.3,50.8a2.77,2.77,0,0,1-2.1,1.3Z" transform="translate(-18.9 -18.9)"/></svg>
                  </div>
                  <p class="usb-modal-experience-text small m-0">{{ info }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div style="margin-left: 2.8em; margin-right: 2em; margin-top: 50px;"> -->
    <!--   <p style="font-family: &quot;Poppins&quot;, serif; font-size: 19px; font-weight: 600; padding-left: 1.2em">Información general</p> -->
    <!--   <div class="d-flex flex-column justify-content-center" style="width: 100%; height: 85px;"> -->
    <!--     <div class="d-flex align-items-center" style="padding-left: 1.2em"> -->
    <!--       <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" width="26px" height="26px" alt="" /> -->
    <!--       <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.15em"> -->
    <!--         Cancelación {{ product?.additionalInfo?.tours?.options[0]?.rateClass === "R" ? "gratuita" : "" }} -->
    <!--       </p> -->
    <!--     </div> -->
    <!--     <p -->
    <!--       class="mb-0" -->
    <!--       style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 3.75em" -->
    <!--     > -->
    <!--       <span *ngIf="product?.additionalInfo?.tours?.options[0]?.rateClass === 'R'"> -->
    <!--         Cancela gratis hasta {{ product?.additionalInfo?.tours?.options[0]?.cancellation_policy[0]?.dateFrom | date: "dd/MM/yyyy" }} y -->
    <!--         recibe un reembolso completo -->
    <!--       </span> -->
    <!--       <span *ngIf="product?.additionalInfo?.tours?.options[0]?.rateClass === 'NR'"> Cancelación con 100% de cargo </span> -->
    <!--     </p> -->
    <!--   </div> -->
    <!--   <div class="d-flex" style="border-top: 1px solid #b4b4b4; border-bottom: 1px solid #b4b4b4; height: 85px"> -->
    <!--     <div class="d-flex flex-column justify-content-center" style="width: 100%; border-right: 1px solid #b4b4b4"> -->
    <!--       <div class="d-flex align-items-center" style="padding-left: 1.2em"> -->
    <!--         <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="24px" alt="" /> -->
    <!--         <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.25em"> -->
    <!--           Duración {{ getDurations(product?.additionalInfo?.tours?.options) }} -->
    <!--         </p> -->
    <!--       </div> -->
    <!--       <p -->
    <!--         *ngIf="periodsActivities(product?.additionalInfo?.tours?.options) !== ''" -->
    <!--         class="mb-0" -->
    <!--         style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 3.6em" -->
    <!--       > -->
    <!--         Suele estar disponible por la {{ periodsActivities(product?.additionalInfo?.tours?.options) }} -->
    <!--       </p> -->
    <!--       <p -->
    <!--         *ngIf="periodsActivities(product?.additionalInfo?.tours?.options) === ''" -->
    <!--         class="mb-0" -->
    <!--         style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 3.6em" -->
    <!--       > -->
    <!--         <span -->
    <!--           *ngIf=" -->
    <!--             product?.scheduling && -->
    <!--             product?.scheduling && -->
    <!--             product?.scheduling.length > 0 && -->
    <!--             product?.scheduling[0]?.opened && -->
    <!--             product?.scheduling[0]?.opened.length > 0 -->
    <!--           " -->
    <!--         > -->
    <!--           Abierto desde {{ product?.scheduling[0].opened[0].openingTime }} hs. hasta -->
    <!--           {{ product?.scheduling[0].opened[0].closeTime }} hs. -->
    <!--         </span> -->
    <!--         <span *ngIf="product?.scheduling.length === 0"> Suele estar abierto todo el día </span> -->
    <!--       </p> -->
    <!--     </div> -->
    <!--     <div class="d-flex flex-column justify-content-center ml-3" style="width: 100%"> -->
    <!--       <div class="d-flex align-items-center"> -->
    <!--         <img src="../../../../../assets/icons/search-result/tour/idioma.svg" width="23px" alt="" /> -->
    <!--         <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.5em"> -->
    <!--           Idioma -->
    <!--         </p> -->
    <!--       </div> -->
    <!--       <p -->
    <!--         class="mb-0" -->
    <!--         style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 2.4em" -->
    <!--       > -->
    <!--         La actividad se realiza {{ getGuideAmenity(product?.additionalInfo?.tours?.amenities.included) }} -->
    <!--         <span style="text-transform: lowercase">{{ getLanguages(product?.additionalInfo?.tours?.options) }}</span> -->
    <!--       </p> -->
    <!--     </div> -->
    <!--   </div> -->
    <!--   <div class="d-flex flex-column justify-content-center" style="margin-bottom: 30px; height: 85px;" [ngStyle]="{ 'border-bottom': product?.comments?.averageStars > 0 ? 'none' : '1px solid #b4b4b4'}"> -->
    <!--     <div class="d-flex align-items-center" style="padding-left: 1.2em"> -->
    <!--       <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="21px" alt="" /> -->
    <!--       <p class="mb-0" style="font-family: &quot;Poppins&quot;, serif; font-size: 14px; font-weight: 600; margin-left: 0.5em"> -->
    <!--         Ubicación -->
    <!--       </p> -->
    <!--     </div> -->
    <!--     <p -->
    <!--       class="mb-0" -->
    <!--       style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 13px; font-weight: 400; line-height: 1; margin-left: 3.7em" -->
    <!--     > -->
    <!--       {{ product?.additionalInfo?.location ? product?.additionalInfo?.location + ", " + payload[0]?.city : payload[0]?.city }} -->
    <!--     </p> -->
    <!--   </div> -->
    <!--   <div *ngIf="product?.additionalInfo?.routes && product?.additionalInfo?.routes.length > 0"> -->
    <!--     <div class="d-flex flex-column mt-4"> -->
    <!--       <div style="width: 30%"> -->
    <!--         <p style="font-family: &quot;Poppins&quot;, serif; font-size: 19px; font-weight: 600; padding-left: 1.2em">Rutas</p> -->
    <!--       </div> -->
    <!--       <div class="d-flex flex-column mb-2" style="width: 100%"> -->
    <!--         <ng-container *ngFor="let route of product?.additionalInfo?.routes; let routeIndex = index"> -->
    <!--           <div -->
    <!--             class="d-flex justify-content-between align-items-center" -->
    <!--             style="padding: 14px 10px 14px 22px; border: 1px solid #ececec; margin-bottom: 10px;" -->
    <!--           > -->
    <!--             <p class="mb-0 vehicle-middle-description" style="font-weight: 500; line-height: 1; font-size: 13px !important"> -->
    <!--               {{ route.description }}: {{ route.duration }} -->
    <!--             </p> -->
    <!--             <button -->
    <!--               type="button" -->
    <!--               style=" -->
    <!--                 font-family: 'Poppins', sans-serif; -->
    <!--                 font-size: 13px; -->
    <!--                 font-weight: 500; -->
    <!--                 border: none; -->
    <!--                 background-color: transparent; -->
    <!--               " -->
    <!--               [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }" -->
    <!--               (click)="toggleRoute(product?.additionalInfo?.routes, routeIndex)" -->
    <!--             > -->
    <!--               {{ selectedRouteIndex === routeIndex ? "Ocultar" : "Ver" }} detalle -->
    <!--             </button> -->
    <!--           </div> -->
    <!--         </ng-container> -->
    <!--       </div> -->
    <!--     </div> -->
    <!--     <div style="margin-bottom: 35px;" *ngIf="stopsRoute && stopsRoute.length > 0"> -->
    <!--       <div class="d-flex p-3" style="gap: 1em; border: 1px solid #ececec"> -->
    <!--         <div class="route-timeline" style="width: 50%; height: fit-content"> -->
    <!--           <div *ngFor="let stop of stopsRoute; let j = index" class="timeline-stop"> -->
    <!--             <div -->
    <!--               class="stop-circle d-flex justify-content-center align-items-center" -->
    <!--               style="border: 2px solid #000000; width: 35px !important; height: 35px !important" -->
    <!--               [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }" -->
    <!--             > -->
    <!--               <span class="stop-order" style="color: #000000; font-size: 14px !important"> -->
    <!--                 {{ stop.order }} -->
    <!--               </span> -->
    <!--             </div> -->
    <!--             <div -->
    <!--               class="stop-info" -->
    <!--               (click)="selectStop(stop)" -->
    <!--               style="cursor: pointer; border-radius: 5px; padding: 10px !important" -->
    <!--               [ngStyle]="getStopCircleStyles(stop)" -->
    <!--             > -->
    <!--               <span -->
    <!--                 *ngIf="stop?.description" -->
    <!--                 class="stop-description mb-1" -->
    <!--                 style="font-family: &quot;Rubik&quot; !important; font-size: 13px; font-weight: 600 !important" -->
    <!--                 >&nbsp;{{ stop.description }}</span -->
    <!--               > -->
    <!--               <span style="font-family: &quot;Rubik&quot;; font-size: 12px; line-height: 1.3">&nbsp;Hora: 8:40 hs. - 9:05 hs.</span> -->
    <!--               <span -->
    <!--                 *ngIf="stop?.duration_hours && stop?.duration_minutes" -->
    <!--                 class="stop-description" -->
    <!--                 style="font-family: &quot;Rubik&quot;; font-size: 12px" -->
    <!--                 >&nbsp;Duración: {{ stop?.duration_hours }}:{{ stop?.duration_minutes }} hs.</span -->
    <!--               > -->
    <!--               <span class="stop-city mt-1" style="font-family: &quot;Poppins&quot;; font-size: 9px"></span> -->
    <!--             </div> -->
    <!--           </div> -->
    <!--         </div> -->
    <!--         <div style="width: 100%"> -->
    <!--           <app-map-view -->
    <!--             [coordinatesArr]="stopsRoute" -->
    <!--             [coordinatesSelected]="coordinatesSelected" -->
    <!--             mapMode="route" -->
    <!--             [routeColor]="clientSetting?.clients_setting_global?.color_main_1" -->
    <!--           > -->
    <!--           </app-map-view> -->
    <!--         </div> -->
    <!--       </div> -->
    <!--     </div> -->
    <!--   </div> -->
    <!-- </div> -->
  </div>

  <!-- Opiniones -->
  <div *ngIf="product?.comments?.averageStars > 0" class="d-flex mt-4 pt-5 pb-4" style="background-color: #ececec; padding-left: 3.5em; padding-right: 3.5em; margin-bottom: 25px;">
    <div class="d-flex flex-column" style="width: 35%">
      <div>
        <p class="mb-2" style="font-family: 'Poppins', serif; font-size: 19px; font-weight: 600; line-height: 1">Opiniones</p>
        <p class="mb-2" style="font-family: 'Poppins', serif; font-size: 14px; font-weight: 600; line-height: 1">
          Valoración general
        </p>
      </div>
      <div class="d-flex align-items-center" style="gap: 10px;">
        <ng-container *ngFor="let icon of iconsArr(); let i = index; let last = last">
          <div style="margin-top: 8px; margin-bottom: 15px;" [ngStyle]="{
            'background-color': i < product?.comments?.averageStars ? clientSetting?.clients_setting_global?.color_main_1 : 'transparent',
            'margin-left': i > 0 ? '2px' : '',
            width: '28px',
            height: '28px',
            'border-radius': '50%',
            position: 'relative',
            'z-index': 1,
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'center'
          }">
            <img [src]="getIconsComments(i)" style="width: 30px;transform: scale(1.2)" alt="">
          </div>
        </ng-container>
      </div>
      <p class="mb-2" style="font-family: 'Poppins', serif; font-size: 30px; font-weight: 600; line-height: 1.2">4 / 5</p>
    </div>

    <div class="d-flex flex-column pr-5" style="width: 60%">
      <div style="height: 42px"></div>
      <!-- Guia -->
      <div class="row align-items-center justify-content-between mb-4">
        <div class="col-4">
          <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 14px; font-weight: 600; line-height: 1.2">Guía</p>
        </div>

        <div class="col-6">
          <div style="width: 100%; height: 10px; background-color: #000000; overflow: hidden">
            <div style="width: 92%; height: 100%;" [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"></div>
          </div>
        </div>

        <div class="col-2">
          <div class="d-flex align-items-center" style="gap: 0.5em">
            <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 12px; font-weight: 600; line-height: 1.2">4 / 5</p>
          </div>
        </div>
      </div>

      <!-- Transporte -->
      <div class="row align-items-center justify-content-between mb-4">
        <div class="col-4">
          <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 14px; font-weight: 600; line-height: 1.2">Transporte</p>
        </div>

        <div class="col-6">
          <div style="width: 100%; height: 10px; background-color: #000000; overflow: hidden">
            <div style="width: 80%; height: 100%;" [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"></div>
          </div>
        </div>

        <div class="col-2">
          <div class="d-flex align-items-center" style="gap: 0.5em">
            <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 12px; font-weight: 600; line-height: 1.5">4 / 5</p>
          </div>
        </div>
      </div>

      <!-- Calidad - Precio -->
      <div class="row align-items-center justify-content-between mb-4">
        <div class="col-4">
          <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 14px; font-weight: 600; line-height: 1.2">Calidad - precio</p>
        </div>

        <div class="col-6">
          <div style="width: 100%; height: 10px; background-color: #000000; overflow: hidden">
            <div style="width: 98%; height: 100%;" [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"></div>
          </div>
        </div>

        <div class="col-2">
          <div class="d-flex align-items-center" style="gap: 0.5em">
            <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 12px; font-weight: 600; line-height: 1.5">4 / 5</p>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Extra Information - Experience -->
  <div *ngIf="(product?.additionalInfo?.tours?.amenities?.notIncluded &&  product?.additionalInfo?.tours?.amenities?.notIncluded?.length > 0) || (product?.additionalInfo?.general_info && product?.additionalInfo?.general_info.length > 0) || (product?.additionalInfo?.tours?.amenities?.included && product?.additionalInfo?.tours?.amenities?.included.length > 0)">
    <div
      *ngIf="product?.additionalInfo?.general_info && product?.additionalInfo?.general_info.length > 0"
      class="d-flex mt-4"
      style="border-bottom: 1px solid #ececec; margin-left: 2.8em; margin-right: 2em; padding: 20px 0px;"
    >
      <div style="width: 20%">
        <p class="mb-2 ml-3" style="font-family: &quot;Poppins&quot;, serif; font-size: 19px; font-weight: 600">¿Qué haras?</p>
      </div>
      <div style="width: 100%; padding-top: 5px;">
        <ul>
          <ng-container *ngFor="let info of product?.additionalInfo?.general_info">
            <li>
              <p class="mb-0 vehicle-middle-description" style="font-weight: 400; line-height: 22px; font-size: 14px; font-family: 'Rubik';">{{ info.info }}</p>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>

    <!-- Description -->
    <div
      *ngIf="product?.additionalInfo?.startingPointDescription"
      class="d-flex mt-2"
      style="border-bottom: 1px solid #ececec; margin-left: 2.8em; margin-right: 2em; padding: 20px 0px;"
    >
      <div style="width: 27%">
        <p class="mb-2 ml-3" style="font-family: &quot;Poppins&quot;, serif; font-size: 19px; font-weight: 600">Descripción</p>
      </div>
      <div style="width: 100%; padding-top: 5px;">
        <p class="mb-0 vehicle-middle-description" style="font-weight: 400; line-height:22px; font-size: 14px; font-family: 'Rubik';">{{ product?.additionalInfo?.startingPointDescription }}</p>
      </div>
    </div>

    <!-- Included -->
    <div
      *ngIf="product?.additionalInfo?.tours?.amenities?.included && product?.additionalInfo?.tours?.amenities?.included.length > 0"
      class="d-flex mt-2"
      style="border-bottom: 1px solid #ececec; margin-left: 2.8em; margin-right: 2em; padding: 20px 0px;"
    >
      <div style="width: 20%">
        <p class="mb-2 ml-3" style="font-family: &quot;Poppins&quot;, serif; font-size: 19px; font-weight: 600">Incluye</p>
      </div>
      <div style="width: 100%; padding-top: 5px;">
        <ul style="list-style: none;">
          <ng-container *ngFor="let amenity of product?.additionalInfo?.tours?.amenities?.included">
            <li style="margin-bottom: 5px;">
              <p class="mb-0 vehicle-middle-description" style="font-weight: 400; line-height:22px; font-size: 14px; font-family: 'Rubik';">{{ amenity.description }}</p>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>

    <!-- Not Included -->
    <div
      *ngIf="product?.additionalInfo?.tours?.amenities?.notIncluded &&  product?.additionalInfo?.tours?.amenities?.notIncluded?.length > 0"
      class="d-flex mt-2" style="margin-left:2.8em;margin-right:2em; padding: 20px 0px;"
    >
      <div style="width: 20%;">
        <p class="mb-2 ml-3" style="font-family: 'Poppins', serif; font-size: 19px; font-weight: 600;" >No Incluye</p>
        </div>
      <div style="width: 100%; padding-top: 5px;">
        <ul style="list-style: none;">
          <ng-container *ngFor="let amenity of product?.additionalInfo?.tours?.amenities?.notIncluded">
            <li style="margin-bottom: 5px;"> <p class="mb-0 vehicle-middle-description" style="font-weight: 400; line-height:22px; font-size: 14px; font-family: 'Rubik';">{{amenity.description}}</p></li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="categoryId === 6 && subCategoryId === 9">
  <div class="d-flex flex-column mb-2" style="margin-left: 2.8em; margin-right: 2em">
    <usb-media-banner
      [images]="product.additionalInfo?.images || []"
      [videos]="videoItems"
      [mediaItems]="mediaItems"
      [activeMedia]="activeMedia"
      [activeMediaIndex]="activeMediaIndex"
      [showPlaceholders]="true"
      [height]="350"
      wrapperMargin="0px 2.8em 0px 2.8em"
      (openImage)="openImage.emit($event)"
      (openVideo)="openVideo.emit($event)"
      (selectMedia)="onSelectMedia($event)"
      (seeMorePhotos)="goTabPhotos()"
    ></usb-media-banner>

    <p class="description-tour px-3 mt-3">
      {{ product.description && descriptionComplete ? product.description : (product.description | truncate: 300 : "  ") }}
      <a
        (click)="moreDescription()"
        style="cursor: pointer"
        class="more"
        [ngStyle]="{ color: clientSetting?.clients_setting_global?.color_main_1 }"
        >...más</a
      >
    </p>
  </div>
</ng-container>
